export default {
  inboxApi: {
    getOptionsData: '/api/inbox/getOptionsData',
    getList: '/api/inbox/getList',
    getCount: '/api/inbox/getCount',
    delMessages: '/api/inbox/delMessages',
    sendMessage: '/api/inbox/sendMessage',
    replyMessage: '/api/inbox/replyMessage',
    getDetail: '/api/inbox/getInboxDetail',
    getHis: '/api/inbox/getInboxHis',
  }
}